import React from 'react';

const LoadingSpinner = () => (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8F6] relative overflow-hidden">
        <div className="absolute inset-0 bg-page-gradient opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#C6A34F] mb-4"></div>
            <p className="text-[#C6A34F] font-bold text-lg animate-pulse">Loading experience...</p>
        </div>
    </div>
);

export default LoadingSpinner;
